import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useAuth } from "../../contexts/auth";
import { postOrdersURL, getCustomersURL } from "../../utils/api";
// Chakra imports
import {
    Box,
    Button,
    Flex,
    Icon,
    Spacer,
    Text,
    useColorModeValue,
    FormControl,
    FormLabel,
    Select,
    Input,
    Progress,
    Switch,
    Popover,
    PopoverTrigger,
    PopoverArrow,
    PopoverCloseButton,
    PopoverHeader,
    PopoverBody,
    PopoverContent,
    Divider
} from "@chakra-ui/react";
import { Separator } from "components/Separator/Separator";
// react icons
import { BsArrowRight } from "react-icons/bs";
import useGetCustomers from "../../hooks/useGetCustomers";
import { RepeatIcon, SpinnerIcon, AddIcon } from '@chakra-ui/icons'


function SearchCustomer({
    onCustomerClicked,
}) {
    const textColor = useColorModeValue("gray.700", "white");

    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);

    const [ timer, setTimer     ] = useState(null);
    const [ keyword, setKeyword ] = useState('');
    const [ plateNos, setPlateNos ] = useState('');
    const [ searchedCustomers, setSearchedCustomers ] = useState([]);
    // const [ searching, setSearching ] = useState(false);


    let { 
        customers, 
        totalCustomers, 
        gettingCustomers, 
        setGettingCustomers, 
        gettingCustomersReqSuccess
    } = useGetCustomers({ 
        page: 1, 
        limit: 10, 
        keyword: keyword, 
        plateKeyword: plateNos,
        setErrors: setErrors,
    });

    useEffect(() => {
        if (gettingCustomersReqSuccess) {
            setSearchedCustomers([...customers]);
        }
    }, [customers, gettingCustomersReqSuccess])


    const changeDelay = (change) => {

        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }
        setTimer(
            setTimeout(() => {
                if (change == '') {
                    setSearchedCustomers([]);
                    setKeyword('');
                } else {
                    setKeyword(change);
                    setGettingCustomers(true);
                }
            }, 1500)
        );
    }

    const changePlateDelay = (change) => {

        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }
        setTimer(
            setTimeout(() => {
                if (change == '') {
                    setSearchedCustomers([]);
                    setPlateNos('');
                } else {
                    setPlateNos(change);
                    setGettingCustomers(true);
                }
            }, 1500)
        );
    }

    return (
       <FormControl marginBottom="12px">
            <Box pr="12px" w="100%">
                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                    Search Customer
                </FormLabel>
                <Flex flexDirection="row">
                <Input
                    borderRadius="15px"
                    fontSize="sm"
                    type="text"
                    placeholder="Customer name"
                    size="md" 
                    onChange={(e) => { changeDelay(e.target.value) }}
                />
                <Input
                    borderRadius="15px"
                    fontSize="sm"
                    type="text"
                    placeholder="Plate Nos."
                    size="md" 
                    ml="4px"
                    onChange={(e) => { changePlateDelay(e.target.value) }}
                />
                </Flex>
                
            </Box>
            { gettingCustomers 
                    ? <Progress isIndeterminate />
                    :  searchedCustomers.length > 0 
                        ? <Flex flexDirection="column" w="98%"
                position={"absolute"}
                zIndex={searchedCustomers.length == 0 ? -1 : 99999} 
                backgroundColor="white" 
                maxHeight={200} 
                overflowY="auto" 
                borderColor={"gray"}
                borderWidth={1}
                borderRadius="5px" 
                paddingTop={2}
                marginRight={12}
                >
                { searchedCustomers.map((i) => {
                        return <Flex 
                            flexDirection="column" 
                            w="100%"
                            key={`searched-customers-${i.id}`}
                        >
                            <Box 
                                _hover={{
                                    cursor: "pointer"
                                }}
                                className="row" 
                                ml="12px" mr="12px" 
                                fontSize="s" 
                                >
                                <Box 
                                    _hover={{
                                        textColor: "green"
                                    }}
                                    onClick={(e) => onCustomerClicked({...i})} width="fit-content" >
                                    {i.firstName} {i.lastName} 
                                </Box>
                                {i.cars 
                                ? i.cars.map(c=> { 
                                    return <Popover 
                                        placement="right" 
                                        zIndex={999999}
                                        position="fixed"
                                        >
                                        <PopoverTrigger>
                                        <Button variant="outline" mr="1">{c.carPlate}</Button>
                                        </PopoverTrigger>
                                        <PopoverContent cursor="default">
                                            <PopoverArrow />
                                            <PopoverCloseButton />
                                            <PopoverHeader>Recent transactions/orders</PopoverHeader>
                                            <PopoverBody>
                                                {c.orders.map(o => {
                                                return <>
                                                    <Flex direction="row">
                                                    <Box fontStyle="initial" width="fit-content">{new Date(Date.parse(o.receiveDate)).toLocaleDateString()}</Box> - <Box fontWeight="bold"  width="fit-content"> {o.odometer} Odometer</Box>
                                                    </Flex>
                                                    { o.services.join(', ') }
                                                    <br/><br/>
                                                    <Divider/>
                                                </>
                                                })}
                                            </PopoverBody>
                                        </PopoverContent>
                                    </Popover>
                                })
                                : ''}
                            </Box>
                            <br/>
                            <Separator />
                        </Flex>
                    })}
                
                </Flex>
                : null 
            }
        </FormControl>
    );
}

export default SearchCustomer;